<style lang="scss">
.toast .toast-message {
  z-index: 99999999999 !important;
}
label[for="iframesCardNumber"],
label[for="iframesCardExpiration"],
label[for="iframesCardCvv"] {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}
.cvv {
  font-family: sans-serif;
  box-sizing: border-box;
  display: block;
  height: 50px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 0px;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  width: 100%;
}
#ss-banner {
  background: transparent
    url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-shield@2x.png?raw=true)
    no-repeat left center;
  height: 40px;
  background-size: 280px 34px;
  margin-bottom: 7px;
}

user agent stylesheet div {
  display: block;
}

.form-row {
  margin-top: 10px;
}

.form-wrapper {
  display: block;
  width: 300px;
  margin: 10px auto;
}
.alert-fixed {
  position: fixed;
  top: 6%;
  left: 0;
  width: 100%;
  background: #dc3545 !important;
  text-align: center;
  z-index: 99999999;
  height: 5%;
}
#payment-info {
  display: none;
}
#loading-payment {
  margin-top: 25%;
}
#tokenframe {
  width: 100% !important;
}
@media (max-width: 400px) {
  .paymemt-label {
    font-size: 0.8rem !important;
  }
}
.hidden {
  display: none;
}
#cc_error {
  color: red;
}

$teal:      #5bb8b1;
$teal-dark: #2c7d76;

#f-payement {
  .alert-danger-dim { background: #f7cece90; }

  .table-bg-success {
    background: rgba(91, 184, 177, 0.08);
    border-radius: 10px;
  }

  h5 {
    font-size: 17px;
    font-weight: 700;
    color: $teal-dark;
    margin-bottom: 20px;
  }

  p { font-size: 12px; }

  .abbre-code, .promo-code {
    display: flex;
    flex-direction: column;
    label { width: auto !important; font-size: 13px; font-weight: 600; margin-bottom: 6px; line-height: 1.4; }
    .input-group { width: 100%; }
    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      label { width: 255px !important; line-height: 50px; margin-bottom: 0; flex-shrink: 0; }
    }
  }

  .card .card-body {
    padding: 1.25rem;
    .btn-right { float: right; }
    .cleft     { float: left; }
  }

  /* Remove additional button */
  .bn-remove-btn {
    height: 32px;
    padding: 0 14px;
    border-radius: 8px;
    border: 1.5px solid rgba(220, 53, 69, 0.4);
    background: transparent;
    color: #dc3545;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: background 0.15s, border-color 0.15s;
    margin-left: 6px;
    white-space: nowrap;

    &:hover { background: rgba(220, 53, 69, 0.08); border-color: #dc3545; }
  }

  .payment-type {
    list-style: none;
    padding: 0;

    li {
      padding: 12px 16px;
      background: rgba(91, 184, 177, 0.07);
      border: 1.5px solid rgba(91, 184, 177, 0.2);
      border-radius: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      position: relative;
      transition: background 0.15s, border-color 0.15s;

      &:hover {
        background: rgba(91, 184, 177, 0.14);
        border-color: $teal;
      }

      &.active {
        border-color: $teal-dark;
        background: rgba(91, 184, 177, 0.12);
      }

      .checked-payment {
        position: absolute;
        height: 40px;
        width: 30px;
        top: 0;
        left: 0;
        border-top: 0px solid transparent;
        border-bottom: 41px solid transparent;
        border-left: 40px solid $teal-dark;
      }

      label {
        margin: 0;
        span { margin-left: 10px; font-weight: 600; font-size: 14px; }
        i    { color: $teal-dark; }
      }
    }
  }
}
</style>
<template>
  <section id="f-payement">
    <v-countries-modal
      :li-scrolls="id_scroll_list_country"
      :show-modal="showCountriesWithPhoneCode"
      v-on:closemodal="toggleCountriesPhoneCode"
      :type="'payment'"
    ></v-countries-modal>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-lg-12 col-md-12 mb-5" v-if="getIsApostilleService">
            <h4>{{ getfClientRate.title }}</h4>
            <!-- {{ getApostilleSubmittedData }} -->
            <table class="table table-bg-success mb-5">
              <thead>
                <tr>
                  <th scope="col" style="width: 2%">Qty</th>
                  <th scope="col">Type</th>
                  <th scope="col" class="text-right">Price</th>
                  <th scope="col" class="text-right">Tax</th>
                  <th scope="col" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-center">{{ getApostilleSubmittedData.total_cost.regular_rate.qty }}</th>
                  <td class="">{{ getApostilleSubmittedData.total_cost.regular_rate.title }}</td>
                  <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.regular_rate.rate).toFixed(2) }}</td>
                  <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.regular_rate.tax).toFixed(2) }}</td>
                  <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.regular_rate.rate + getApostilleSubmittedData.total_cost.regular_rate.tax).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="getTranslationRateStatus">
              <h4>{{ getApostilleSubmittedData.total_cost.document_translation_rate.title }}</h4>
              <table class="table table-bg-success mb-5">
                <thead>
                  <tr>
                    <th scope="col" style="width: 2%">SN</th>
                    <th scope="col" class="">Type</th>
                    <th scope="col" class="">Pages</th>
                    <th scope="col" class="text-right">Price</th>
                    <th scope="col" class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-center">1</th>
                    <td>Apostille Certificate</td>
                    <td class="">{{ getApostilleSubmittedData.total_cost.certificate_translation_rate.qty }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.certificate_translation_rate.rate).toFixed(2) }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.certificate_translation_rate.rate * getApostilleSubmittedData.total_cost.certificate_translation_rate.qty).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <th class="text-center">2</th>
                    <td>Uploaded Document</td>
                    <td class="">{{ getApostilleSubmittedData.total_cost.document_translation_rate.qty }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.document_translation_rate.rate).toFixed(2) }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.document_translation_rate.rate * getApostilleSubmittedData.total_cost.document_translation_rate.qty).toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="getScanRateStatus">
              <h4>{{ getApostilleSubmittedData.total_cost.scan_rate.title }}</h4>
              <table class="table table-bg-success mb-5">
                <thead>
                  <tr>
                    <th scope="col" style="width: 2%">SN</th>
                    <th scope="col" class="">Type</th>
                    <th scope="col" class="">Pages</th>
                    <th scope="col" class="text-right">Price</th>
                    <th scope="col" class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-center">1</th>
                    <td>Apostille Certificate</td>
                    <td class="">{{ getApostilleSubmittedData.total_cost.scan_rate.qty }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.scan_rate.rate).toFixed(2) }}</td>
                    <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.scan_rate.rate * getApostilleSubmittedData.total_cost.scan_rate.qty).toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4>Shipping Cost</h4>
            <table class="table table-bg-success mb-5">
              <thead>
                <tr>
                  <th scope="col" style="width: 2%">SN</th>
                  <th scope="col">Company</th>
                  <th scope="col" class="text-right">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-center">1</th>
                  <td class="">{{ getApostilleSubmittedData.total_cost.shipping_cost.title }}
                    <div>
                      <div style=" font-weight: 500;">Shipping Address: </div>
                      <div style="" class="description" v-html="getApostilleSubmittedData.total_cost.shipping_cost.delivery_address"></div>
                    </div>
                  </td>
                  <td class="text-right">${{ parseFloat(getApostilleSubmittedData.total_cost.shipping_cost.rate).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="getApostilleSubmittedData.total_cost.shipping_cost.shipping_type == 'Domestic'" class="d-flex" style="gap: 20px; justify-content: end;"
                @click="updateIsSignatureRequired(!getIsSignatureRequired)">
              <div><input class="m-0 form-check-input" type="checkbox" :checked="getIsSignatureRequired" style="height: 20px;"/></div> <span>Signature Required?</span>
            </div>
          </div>
          <div
            class="col-lg-12 col-md-12 mb-5"
            v-if="
              (is_both_card &&
                getEnableOriRate &&
                getServiceOriCode.success == true &&
                updateServiceOriCode != '') ||
                !getEnableOriRate && !getIsApostilleService
            "
          >
            <p class="bn-service-title">{{ getfClientRate.title }}</p>
            <table
              class="table table-bg-success"
              v-if="!is_archival && !is_renew"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 2%">Qty</th>
                  <th scope="col" class="text-right">Price</th>
                  <th scope="col" class="text-right">Tax</th>
                  <th scope="col" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    {{
                      getfClientRate.service.is_drug_testing
                        ? parseInt(getQty)
                        : getfClientRate.service.default_qty
                    }}
                  </th>
                  <td class="text-right">${{ getfClientRate.rate }}</td>
                  <td
                    class="text-right"
                    v-if="getfClientRate.service.is_drug_testing"
                  >
                    ${{
                      (getfClientRate.rate * parseInt(getQty))
                        | taxAmount(getfClientRate.tax_percentage)
                    }}
                  </td>
                  <td class="text-right" v-else>
                    ${{
                      getfClientRate.rate
                        | taxAmount(getfClientRate.tax_percentage)
                    }}
                  </td>
                  <td
                    class="text-right"
                    v-if="getfClientRate.service.is_drug_testing"
                  >
                    ${{ getTotalRateAmount }}
                  </td>
                  <td class="text-right" v-else>${{ getTotalRateAmount }}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="row"
              v-if="
                getfClientRate.service.is_drug_testing &&
                  !is_archival &&
                  !is_renew
              "
            >
              <div class="col-md-4 mt-5">
                <label for=""><h6>Quantity :</h6></label>
              </div>
              <div class="input-group mb-2 col-md-8">
                <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  @change="setQty"
                  v-model="qty"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
              </div>
            </div>
          </div>

          <div
            class="col-lg-12 col-md-12"
            v-if="
              getfClientRate.has_additional_rate > 0 &&
                !getfClientRate.service.is_drug_testing &&
                !is_archival &&
                !is_renew
            "
          >
            <p class="bn-add-label">{{ getfClientRate.service.additional_field_note ? getfClientRate.service.additional_field_note : 'Additional Cards' }}:</p>
            <div class="bn-qty-ctrl">
              <button class="bn-qty-btn bn-qty-btn--minus" @click="miuQty_()" type="button">
                <i class="fa fa-minus"></i>
              </button>
              <span class="bn-qty-val">{{ getAddQty }}</span>
              <button class="bn-qty-btn bn-qty-btn--plus" @click="addQty_()" type="button">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <table class="table table-bg-success">
              <thead>
                <tr>
                  <th scope="col" style="width: 2%">Qty</th>
                  <th scope="col" class="text-right">Price</th>
                  <th scope="col" class="text-right">Tax</th>
                  <th scope="col" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{{ getAddQty }}</th>
                  <td class="text-right">
                    ${{ getfClientRate.additional_rate }}
                  </td>
                  <td class="text-right">
                    ${{
                      (getfClientRate.additional_rate * getAddQty)
                        | taxAmount(getfClientRate.tax_percentage)
                    }}
                  </td>
                  <td class="text-right">${{ getTotalAdditionalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12">
            <hr />
            <div class="row" v-if="is_archival" style="margin-top: 10px">
              <div class="col-6">
                <div class="form-group">
                  <label for="">Archival Period:</label>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="archival_period"
                    @change="setArchival"
                  >
                    <option value="">None</option>

                    <option
                      v-for="(citem, index) in getArchivalRates"
                      :key="index"
                      :value="citem.archival_period.id"
                    >
                      {{ citem.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 m-0" v-if="is_renew">
                <div class="form-group">
                  <label for=""> Select Date</label>
                  <input
                    type="date"
                    v-model="selected_renew_date"
                    class="form-control"
                    id="inputdate"
                    name="inputdate"
                    @change="setRenewDate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <h5 class="float-right" v-if="getPromoCodeDiscountRate > 0">
              Discount ({{ getPromoCodeDiscountRate }}%): ${{
                getTotalDiscountAmount
              }}
            </h5>
          </div>
          <div class="col-12">
            <h5
              class="float-right"
              v-if="
                front_status && getAbbreviationCode.data.show_payment_option
              "
            >
              Total: ${{ getTotalServiceAmount }}
            </h5>

            <div
              v-if="
                !getAbbreviationCode.success &&
                  abbreviation_code_error &&
                  updateAbbreviationCode != ''
              "
              class="alert alert-custom alert-danger-dim alert-shadow fade show gutter-b"
              role="alert"
            >
              <div class="alert-text" v-html="getAbbreviationCode.msg"></div>
            </div>
          </div>

          <p
            v-html="getSettingNote.abbreviation_code_note"
            v-if="front_status"
          ></p>
          <div class="col-12 abbre-code">
            <label
              >Company Abbreviation Code :
              <strong
                class="text-uppercase"
                v-if="
                  getAbbreviationCode.success == true &&
                    abbreviation_code_error &&
                    updateAbbreviationCode != ''
                "
                >{{ updateAbbreviationCode }}</strong
              >
            </label>
            <div
              class="input-group mb-3"
              :hidden="getAbbreviationCode.success == true"
            >
              <input
                @input="updateAbCode"
                class="form-control text-uppercase"
                v-model="abree_code"
                v-mask="'XXXXXXXXXX'"
                type="text"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-success"
                  @click="checkAbbreviationCode()"
                  type="button"
                  style="z-index: 0"
                >
                  Use
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-md-12"
            v-if="
              getAbbreviationCode.success == true &&
                abbreviation_code_error &&
                updateAbbreviationCode != ''
            "
            style="margin-top: 10px"
          >
            <div class="row">
              <div class="col-md-12">
                <ul style="list-style: none; padding: 0">
                  <li>
                    Name :
                    <b>{{ getAbbreviationCode.data.company_name }}</b>
                  </li>
                  <li>
                    Address :
                    <b> {{ getAbbreviationCode.data.address }}</b>
                  </li>
                  <li class="mt-2">
                    <a
                      style="cursor: pointer"
                      @click="removeAbbCode()"
                      class="btn btn-danger"
                    >
                      <i class="fa fa-times"></i> Remove Company Abbreviation Code
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div
              v-if="
                !getPromoCode.success &&
                  promo_code_error &&
                  updatePromoCode != ''
              "
              class="alert alert-custom alert-danger-dim alert-shadow fade show gutter-b"
              role="alert"
            >
              <div class="alert-text" v-html="getPromoCode.msg"></div>
            </div>
          </div>
          <div class="col-12 promo-code" v-if="front_status">
            <label>
              <span
                v-if="
                  getPromoCode.success == true &&
                    !promo_code_error &&
                    updatePromoCode != ''
                "
                >Promo Code ({{ getPromoCode.data.title }}) :</span
              >
              <span v-else>Promo Code :</span>
              <strong
                v-if="
                  getPromoCode.success == true &&
                    !promo_code_error &&
                    updatePromoCode != ''
                "
                class="text-uppercase"
                >{{ updatePromoCode }}</strong
              >
            </label>
            <div
              class="input-group mb-3"
              :hidden="getPromoCode.success == true"
            >
              <input
                @input="updatePRCode"
                class="form-control text-uppercase"
                v-model="promo_code"
                v-mask="'XXXXXXXXXX'"
                type="text"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-success"
                  @click="checkPromoCode()"
                  type="button"
                  style="z-index: 0"
                >
                  Use
                </button>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="archivalItem != 0">
            <table class="table table-bg-success">
              <thead>
                <tr>
                  <th scope="col-4" class="text-right">Price</th>
                  <th scope="col-4" class="text-right">Tax</th>
                  <th scope="col-4" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-right">${{ archivalItem.rate }}</td>
                  <td class="text-right">
                    ${{
                      archivalItem.rate | taxAmount(archivalItem.tax_percentage)
                    }}
                  </td>
                  <td class="text-right">${{ archival_total }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-12"
            v-if="
              getPromoCode.success == true &&
                !promo_code_error &&
                updatePromoCode != ''
            "
            style="margin-top: 10px"
          >
            <div class="row">
              <div class="col-md-12">
                <ul style="list-style: none; padding: 0">
                  <!-- <li>
                    Promo title:
                    <b>{{ getPromoCode.data.title }}</b>
                  </li> -->
                  <li class="mt-2">
                    <a
                      style="cursor: pointer"
                      @click="removePromoCode()"
                      class="btn btn-danger"
                    >
                      <i class="fa fa-times"></i> Remove Promo Code
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-if="
                !getServiceOriCode.success &&
                  service_ori_code_error &&
                  updateServiceOriCode != ''
              "
              class="col-md-12 alert alert-custom alert-danger-dim alert-shadow fade show gutter-b"
              role="alert"
            >
              <div class="alert-text" v-html="getServiceOriCode.msg"></div>
            </div>
          </div>

          <div
            class="col-md-8 col-lg-12 col-sm-12 col-12 abbre-code"
            v-if="getEnableOriRate"
          >
            <label
              >ORI :
              <strong
                class="text-uppercase"
                onchange="change_ori"
                v-if="getServiceOriCode.success == true"
                >{{ updateServiceOriCode }}</strong
              >
            </label>
            <div
              class="input-group mb-3"
              :hidden="getServiceOriCode.success == true"
            >
              <input
                v-if="!front_status"
                class="form-control text-uppercase"
                v-model="service_ori"
                type="text"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                @input="updateOri"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-success"
                  @click="checkServiceOri()"
                  type="button"
                  style="z-index: 0"
                >
                  Use
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-md-12"
            v-if="getServiceOriCode.success == true"
            style="margin-top: 10px"
          >
            <div class="row">
              <div class="col-md-5">
                <ul style="list-style: none; padding: 0">
                  <li>
                    Name :
                    <b>{{ getServiceOriCode.data.profession }}</b>
                  </li>
                  <!-- <li>
                Address : <b> {{ getAbbreviationCode.data.address }}</b>
              </li> -->
                  <li class="mt-2" v-if="!front_status">
                    <a
                      style="cursor: pointer"
                      @click="removeServiceOri()"
                      class="btn btn-danger"
                    >
                      <i class="fa fa-times"></i> Remove ORI
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="this.getServiceProviderData.payment_method == 'cardpointe'"
        v-show="paymentMethod"
      >
        <div class="row">
          <div class="col-md-12" id="loading-payment">
            <loading-spinner style="margin-top: 20px"> </loading-spinner>
          </div>
          <div class="col-md-12" id="payment-info">
            <h5>Payment Information</h5>
            <hr />
            <ul class="payment-type">
              <li>
                <label for="">
                  <img
                    src="@/assets/images/icon/png/card.png"
                    width="20%"
                    alt=""
                  />
                  <span>Card Payment</span></label
                >

                <div
                  style="padding: 10px; background: #eef0f8; margin-top: 10px"
                >
                  <div class="d-flex">
                    <label
                      for=""
                      style="
                        margin-top: 5px;
                        width: 60%;
                        float: left;
                        font-weight: 500;
                      "
                      >Supported Cards</label
                    >
                    <img
                      style="width: 40%; float: left"
                      src="@/assets/images/card/card_icon_v1_all.svg"
                      alt=""
                    />
                  </div>
                  <hr />
                  <div class="row">
                    <div class="form-group col-md-6 col-6 cd-field">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Card Number</label
                      >
                      <!-- <div id="myToken"></div> -->
                      <div class="hidden" name="mytoken" id="mytoken"></div>
                      <!-- <input type="hidden" name="cardtype" id="cardtype" /> -->
                      <form name="tokenform" id="tokenform">
                        <iframe
                          id="tokenframe"
                          name="tokenframe"
                          scrolling="no"
                          height="52"
                          width="200"
                          autofocus="true"
                          frameborder="0"
                        ></iframe>
                      </form>
                      <div id="cc_error" class="cd-err-row hidden">
                        Please enter a valid credit card number
                      </div>
                      <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_number']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" && errors["card_number"][0]
                        }}</span
                      >
                      <div
                        class="input-group-prepend"
                        v-if="getPaymentCardType != ''"
                      >
                        <span
                          class="input-group-text"
                          id="basic-addon1"
                          style="padding: 0; background: white; border: none"
                        >
                          <img
                            :src="
                              require('@/assets/images/card/card_icon_v1_' +
                                getPaymentCardType +
                                '.svg')
                            "
                            width="85%"
                            height="30px"
                            alt=""
                          />
                        </span>
                      </div>
                      <!-- <div>
                      <input
                      type="text"
                      class="form-control"
                      placeholder="Enter card Number"
                      :value="getPaymentCardNumber"
                      @input="updateCardNumber"
                      v-mask="'#### #### #### ####'"
                    />
                    <img src="@/assets/images/card/card_icon_v1_visa.svg" alt="">
                    </div> -->
                      <!-- <small id="emailHelp" class="form-text  text-danger"
                      >Card No. cannot be empty</small
                    > -->
                      <!-- <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter card Number"
                        :value="getPaymentCardNumber"
                        @input="updateCardNumber"
                        v-mask="'#### #### #### ####'"
                        :class="
                          this.getPaymentType == 'C' && errors['card_number']
                            ? 'border border-danger'
                            : ''
                        "
                      />
                      <div
                        class="input-group-prepend"
                        v-if="getPaymentCardType != ''"
                      >
                        <span
                          class="input-group-text"
                          id="basic-addon1"
                          style="padding: 0; background: white; border: none"
                        >
                          <img
                            :src="
                              require('@/assets/images/card/card_icon_v1_' +
                                getPaymentCardType +
                                '.svg')
                            "
                            width="85%"
                            height="30px"
                            alt=""
                          />
                        </span>
                      </div>
                    </div> -->
                    </div>
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Expiration date</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="MM/YY"
                        v-mask="'##/##'"
                        @input="updateCardExpiry"
                        :value="getPaymentCardExpiry"
                        :class="
                          this.getPaymentType == 'C' && errors['card_expiry']
                            ? 'border border-danger'
                            : ''
                        "
                      />

                      <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_expiry']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" && errors["card_expiry"][0]
                        }}</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Cardholder Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Cardholder Name"
                        :value="getPaymentCardHolderName"
                        @input="updateCardHolderName"
                        :class="
                          this.getPaymentType == 'C' &&
                          errors['card_holder_name']
                            ? 'border border-danger'
                            : ''
                        "
                      />
                      <span
                        v-if="
                          this.getPaymentType == 'C' &&
                            errors['card_holder_name']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" &&
                            errors["card_holder_name"][0]
                        }}</span
                      >
                    </div>
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 text-uppercase mb-1 paymemt-label"
                        >Security Code</label
                      >

                      <input
                        type="text"
                        class="form-control"
                        max="9999"
                        :placeholder="getPaymentCardProperty.cvv_placeholder"
                        v-mask="getPaymentCardProperty.cvv_mask"
                        @input="updateCardCvvNumber"
                        :value="getPaymentCardCvvNumber"
                        :class="
                          this.getPaymentType == 'C' && errors['card_cvv_no']
                            ? 'border border-danger'
                            : ''
                        "
                      />

                      <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_cvv_no']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" && errors["card_cvv_no"][0]
                        }}</span
                      >
                    </div>
                  </div>
                  <hr />
                  <div
                    style="
                      padding: 0 0 1%;
                      background: #eef0f8;
                      margin-top: 10px;
                    "
                  >
                    <div class="d-flex">
                      <label
                        for=""
                        style="width: 60%; float: left; font-weight: 500"
                        >Billing Address</label
                      >
                    </div>
                    <span style="opacity: 0.5"
                      >As it appears on credit card statement.</span
                    >
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Address</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Address"
                        :value="getPaymentCardHolderAddress"
                        @input="updateCardAddress"
                      />
                      <!-- <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_address']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" &&
                            errors["card_address"][0]
                        }}</span
                      > -->
                    </div>
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >City</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="City"
                        :value="getPaymentCardHolderCity"
                        @input="updateCardcity"
                      />
                      <!-- <span
                        v-if="this.getPaymentType == 'C' && errors['card_city']"
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" && errors["card_city"][0]
                        }}</span
                      > -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Country</label
                      >
                      <select class="form-control" @change="updateCountry">
                        <option value="" hidden>Select Country</option>
                        <option
                          v-for="(item, index) in getCountries"
                          :key="index"
                          :value="item.country_code"
                          :selected="
                            getPaymentCardHolderCountry == item.country_code
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <!-- <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_country']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" &&
                            errors["card_country"][0]
                        }}</span
                      > -->
                    </div>
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >State</label
                      >
                      <select
                        class="form-control"
                        @change="updateState"
                        v-if="getPaymentCardHolderCountry == 'US'"
                      >
                        <option value="">Select State</option>
                        <option
                          v-for="(item, index) in getStates"
                          :key="index"
                          :value="item.name"
                          :selected="getPaymentCardHolderState == item.name"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <input
                        v-else
                        type="text"
                        class="form-control"
                        placeholder="State"
                        :value="getPaymentCardHolderState"
                        @input="updateState"
                      />
                      <!-- <span
                        v-if="
                          this.getPaymentType == 'C' && errors['card_state']
                        "
                        class="text-danger"
                        >{{
                          this.getPaymentType == "C" && errors["card_state"][0]
                        }}</span
                      > -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Postal/Zip</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Postal/Zip"
                        @input="updatePostalZip"
                        :value="getPaymentCardPostalZip"
                      />
                    </div>
                    <div class="form-group col-md-6 col-6">
                      <label
                        for="exampleInputEmail1"
                        class="ml-0 mb-1 text-uppercase paymemt-label"
                        >Phone</label
                      >
                      <div class="input-group mb-3">
                        <div
                          class="input-group-prepend"
                          @click="toggleCountriesPhoneCode(true)"
                          style="cursor: pointer; border-right: 1px solid"
                        >
                          <span
                            class="input-group-text"
                            id="basic-addon1"
                            style="
                              min-width: 80px;
                              max-width: 80px;
                              text-align: center;
                            "
                          >
                            <img
                              :src="getPaymentCardPhonecode.flag"
                              alt=""
                              class="mr-1"
                            />
                            <b style="width: 100%; text-align: center">{{
                              getPaymentCardPhonecode.dial_code
                            }}</b>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          :value="getPaymentCardPhone"
                          @input="updatePaymentCardPhone"
                          v-mask="'(###)-###-####'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <div
                class="form-group mt-0 mb-0"
                style="display: inline-flex"
                v-if="getClientEnableOnSitePayment && !getIsApostilleService"
              >
                <input
                  type="checkbox"
                  name="on_site_payment"
                  id="on_site_payment"
                  v-model="onSitePayment"
                  @change="updatePaymentType(1)"
                />
                <label
                  class="ml-2"
                  for="on_site_payment"
                  style="margin-top: 11px"
                  >Click here for on-site payment</label
                >
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="col-md-6"
        v-if="this.getServiceProviderData.payment_method == 'heartland'"
        v-show="paymentMethod"
      >
        <div class="row">
          <div class="col-md-12">
            <h5>Payment Information</h5>
            <hr />
            <ul class="payment-type">
              <li>
                <div style="padding: 10px; background: #eef0f8">
                  <div class="hidden" name="mytoken" id="mytoken"></div>
                  <div class="hidden" name="expiremonth" id="expiremonth"></div>
                  <div class="hidden" name="expireyear" id="expireyear"></div>
                  <div class="hidden" name="card_type" id="card_type"></div>
                  <div class="hidden" name="last_four" id="last_four"></div>
                  <div class="hidden" name="token_type" id="token_type"></div>

                  <div class="form-wrapper">
                    <form id="iframes" action="" method="GET">
                      <div id="ss-banner"></div>

                      <div class="form-row">
                        <label for="iframesCardNumber">Card Number:</label>
                        <div id="iframesCardNumber"></div>
                      </div>

                      <div class="form-row">
                        <label for="iframesCardExpiration"
                          >Card Expiration:</label
                        >
                        <div id="iframesCardExpiration"></div>
                      </div>

                      <div class="form-row">
                        <label for="iframesCardCvv">Card CVV:</label>
                        <div id="iframesCardCvv"></div>
                      </div>
                      <br />
                    </form>
                    <div class="form-row">
                      <label for="iframesCardCvv">Address</label>
                      <input
                        style=""
                        type="text"
                        class="cvv"
                        placeholder="Address"
                        :value="getPaymentCardHolderAddress"
                        @input="updateCardAddress"
                      />
                    </div>
                    <div class="form-row">
                      <label for="iframesCardCvv">Postal/Zip</label>
                      <input
                        style=""
                        type="text"
                        class="cvv"
                        placeholder="Postal/Zip"
                        @input="updatePostalZip"
                        :value="getPaymentCardPostalZip"
                      />
                    </div>
                  </div>
                </div>
              </li>
              <div
                class="form-group mt-0 mb-0"
                style="display: inline-flex"
                v-if="getClientEnableOnSitePayment && !getIsApostilleService"
              >
                <input
                  type="checkbox"
                  name="on_site_payment"
                  id="on_site_payment"
                  v-model="onSitePayment"
                  @change="updatePaymentType(1)"
                />
                <label
                  class="ml-2"
                  for="on_site_payment"
                  style="margin-top: 11px"
                  >Click here for on-site payment</label
                >
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import vCountriesForPhoneCode from "@/components/frontend/modal/countriesforphonecode";
import loadingSpinner from "@/components/frontend/spinner.vue";
import { load } from "recaptcha-v3";

/*  eslint-disable */
// import Heartland from "@/assets/js/components/Heartland.js";
// window.Heartland = Heartland;
import moment from "moment";
/* eslint-enable */

import {
  UPDATE_ABBREVIATION_CODE,
  UPDATE_PAYMENT_TYPE,
  SET_PAYMENT_CARD_NUMBER,
  SET_PAYMENT_CARD_HOLDER_NAME,
  SET_PAYMENT_CARD_ADDRESS,
  SET_PAYMENT_CARD_EXPIRY_DATE,
  SET_PAYMENT_CARD_CVV_NUMBER,
  SET_PAYMENT_CARD_TYPE,
  SET_CHECK_F_ABBREVIATION_CODE,
  SET_RATE_TOTAL_AMOUNT,
  SET_ADD_RATE_QTY,
  SET_PAYMENT_CARD_PROPERTY,
  CARD_STATE,
  CARD_COUNTRY,
  SET_PAYMENT_CARD_CITY,
  SET_PAYMENT_CARD_NUMBER_POSTAL,
  SET_PAYMENT_CARD_NUMBER_PHONE,
  ISHEARTSPAYMENT,
  SET_QTY,
  RECAPTCHATOKEN,
  SET_TOTAL_SERVICE_AMOUNT,
  SET_ARCHIVAL_PERIOD_ID,
  // SET_F_ARCHIVAL_CLIENT_RATE
  SET_ADDITIONAL_CARD_TOTAL_AMOUNT,
  SET_ARCHIVAL_TOTAL_RATE_AMOUNT,
  UPDATE_PROMO_CODE,
  SET_CHECK_F_PROMO_CODE,
  SET_PROMOCODE_DISCOUNT_AMOUNT,
  SET_PROMOCODE_DISCOUNT_PERCENTAGE,
  SET_ARCHIVAL_RENEW_DATE,
  UPDATE_SERVICE_ORI_CODE,
  UPDATE_ORI,
  SET_CHECK_F_SERVICE_ORI_CODE,
  SET_F_CLIENT_RATE,
  SET_IS_SIGNATURE_REQUIRED
} from "@/core/services/store/mutations.type";
import {
  CHECK_F_PROMO_CODE,
  CHECK_F_ABBREVIATION_CODE,
  RECAPTCHATOKENVERIFY,
  CHECK_F_SERVICE_ORI_CODE
} from "@/core/services/store/actions.type";
export default {
  computed: {
    ...mapGetters([
      "getArchivalDate",
      "getArchivalRates",
      "getTotalServiceAmount",
      "getTotalAdditionalAmount",
      "getfClientRate",
      "getTotalRateAmount",
      "getAddQty",
      "getPromoCode",
      "getAbbreviationCode",
      "updateAbbreviationCode",
      "updatePromoCode",
      "getPaymentType",
      "getClientEnableOnSitePayment",
      "getSettingNote",
      "getPaymentCardNumber",
      "getPaymentCardHolderName",
      "getPaymentCardExpiry",
      "getPaymentCardCvvNumber",
      "getPaymentCardType",
      "getPaymentCardProperty",
      "getPaymentCardHolderAddress",
      "getPaymentCardHolderState",
      "getPaymentCardHolderCountry",
      "getPaymentCardHolderCity",
      "getStates",
      "getCountries",
      "getPaymentCardPhone",
      "getPaymentCardPostalZip",
      "getPaymentCardPhonecode",
      "getServiceProviderData",
      "getQty",
      "getTotalArchivalRateAmount",
      "getArchivalPeriodId",
      "getServiceOriCode",
      "updateServiceOriCode",
      "getServiceTypeCode",
      "getTotalDiscountAmount",
      "getPromoCodeDiscountRate",
      "getArchivalRenewDate",
      "getServiceId",
      "getEnableOriRate",
      "getIsApostilleService",
      "getApostilleSubmittedData",
      "getScanRateStatus",
      "getTranslationRateStatus",
      "getIsExpeditedRate",
      "getIsSignatureRequired"
    ])
  },
  components: {
    "v-countries-modal": vCountriesForPhoneCode,
    loadingSpinner
  },
  props: {
    front_status: {
      type: Boolean,
      default: true
    },
    is_both_card: {
      type: Boolean,
      default: true
    },
    is_archival: {
      type: Boolean,
      default: false
    },
    is_renew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      archival_period: "",
      archivalItem: 0,
      selected_renew_date: "",
      set_lower_limit: "",
      set_upper_limit: "",
      sitekey: "6LevxIAfAAAAAB5NDxwhJqj0hGMUI3Ydw0nWIBlO",
      errors: [],
      service_ori: "",
      service_ori_code_error: false,
      addQty: 0,
      paymentMethod: false,
      promo_code: "",
      promo_code_error: false,
      expirationDate: "",
      onSitePayment: false,
      abree_code: "",
      abbreviation_code: "",
      abbreviation_code_error: false,
      myCustomCardTypes: [
        {
          regEx: /^4[0-9]{5}/gi,
          name: "visa",
          icon: require("@/assets/visa_icon.png")
        },
        {
          regEx: /^5[1-5][0-9]{4}/gi,
          name: "mastercard",
          icon: require("@/assets/master_icon.png")
        }
      ],
      showCountriesWithPhoneCode: false,
      id_scroll_list_country: "",
      token: "",
      // hps: "",
      qty: 0
    };
  },
  created() {
    this.archival_period = this.getArchivalPeriodId;
    this.archivalDataFetched(this.archival_period, 0, false);
    this.selected_renew_date = "";
    this.qty = this.getQty;
    this.addQty = this.getAddQty;
    this.onSitePayment = this.getPaymentType == "O" ? 1 : 0;
    if (this.updatePromoCode != "") {
      this.promo_code = this.updatePromoCode;
      this.checkPromoCode();
    }
    let payment_method = this.getServiceProviderData.payment_method;
    this.$store.commit(
      ISHEARTSPAYMENT,
      payment_method == "heartland" ? true : false
    );
  },
  beforeDestroy() {
    if (this.hps) {
      this.hps.dispose();
    }
  },
  mounted() {
    /* eslint-disable */
    let payment_method =
      this.getServiceProviderData.payment_method == "heartland" ? true : false;

    if (payment_method) {
      let that = this;
      this.hps = new Heartland.HPS({
        publicKey: this.getServiceProviderData.public_key,
        type: "iframe",
        fields: {
          cardNumber: {
            target: "iframesCardNumber",
            placeholder: "•••• •••• •••• ••••",
          },
          cardExpiration: {
            target: "iframesCardExpiration",
            placeholder: "MM / YYYY",
          },
          cardCvv: {
            target: "iframesCardCvv",
            placeholder: "CVV",
          },
        },
        style: {
          input: {
            background: "#fff",
            border: "1px solid",
            "border-color": "#bbb3b9 #c7c1c6 #c7c1c6",
            "box-sizing": "border-box",
            "font-family": "serif",
            "font-size": "16px",
            "line-height": "1",
            margin: "0 .5em 0 0",
            "max-width": "100%",
            outline: "0",
            padding: "0.5278em",
            "vertical-align": "baseline",
            height: "50px",
            width: "100% !important",
          },
          "#heartland-field": {
            "font-family": "sans-serif",
            "box-sizing": "border-box",
            display: "block",
            height: "50px",
            padding: "6px 12px",
            "font-size": "14px",
            "line-height": "1.42857143",
            color: "#555",
            "background-color": "#fff",
            border: "1px solid #ccc",
            "border-radius": "0px",
            "-webkit-box-shadow": "inset 0 1px 1px rgba(0,0,0,.075)",
            "box-shadow": "inset 0 1px 1px rgba(0,0,0,.075)",
            "-webkit-transition":
              "border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s",
            "-o-transition":
              "border-color ease-in-out .15s,box-shadow ease-in-out .15s",
            transition:
              "border-color ease-in-out .15s,box-shadow ease-in-out .15s",
            width: "100%",
          },
        },
        onTokenSuccess: function (resp) {
          document.getElementById("mytoken").innerHTML = resp.token_value;
          document.getElementById("expiremonth").innerHTML = resp.exp_month;
          document.getElementById("expireyear").innerHTML = resp.exp_year;
          document.getElementById("token_type").innerHTML = resp.token_type;
          document.getElementById("last_four").innerHTML = resp.last_four;
          document.getElementById("card_type").innerHTML = resp.card_type;
        },
        onTokenError: function (resp) {
          document.getElementById("mytoken").innerHTML = '';
          document.getElementById("expiremonth").innerHTML = '';
          document.getElementById("expireyear").innerHTML = '';
          document.getElementById("token_type").innerHTML = '';
          document.getElementById("last_four").innerHTML = '';
          document.getElementById("card_type").innerHTML = '';
        },
        onEvent: function (ev) {
          if(ev.classes.includes("valid")) {
            that.tokenize();
          }
        },
      });
    }
    if (this.updateAbbreviationCode != "") {
      this.abree_code = this.updateAbbreviationCode;
      this.checkAbbreviationCode();
    } else {
      this.paymentMethod = true;
    }
    /* eslint-enable */
    if (!payment_method) {
      var frame = document.getElementById("tokenframe");
      frame.addEventListener("load", () => {
        setTimeout(function() {
          document.getElementById("payment-info").style.display = "block";
          document.getElementById("loading-payment").style.display = "none";
        }, 10);
      });
      var mytoken = document.getElementById("mytoken");
      mytoken.innerHTML = "";
      // document.getElementById("myToken").style.display = "none";
      window.addEventListener(
        "message",
        function(event) {
          var token;
          mytoken.innerHTML = "";

          token = JSON.parse(event.data);

          if (token.validationError != undefined) {
            document.getElementById("tokenframe").focus();
            var error = document.getElementById("cc_error");
            error.style.display = "block";
            mytoken.innerHTML = "";

            setTimeout(function() {
              error.style.display = "none";
            }, 2000);
            return false;
          }
          mytoken.innerHTML = token.message;
          // document.getElementById("myToken").fadeIn();
        },
        false
      );
      this.setFrame();
    }
    // this.recaptchafun();

    // let add_rate = parseFloat(this.getfClientRate.rate);
    // this.$store.commit(SET_RATE_TOTAL_AMOUNT, add_rate.toFixed(2));
  },
  filters: {
    taxAmount(amount, taxPer) {
      amount = parseFloat(amount);
      taxPer = parseFloat(taxPer);
      return ((amount * taxPer) / 100).toFixed(2);
    },
    toFixedTwoDigit(amount, data) {
      var rate = parseFloat(data.rate) * parseInt(data.service.default_qty);
      var tp = parseFloat(data.tax_percentage);
      return (parseFloat(amount) + (rate + (rate * tp) / 100)).toFixed(2);
    },
    toFixedTwoDigitRate(data) {
      var rate = parseFloat(data.rate) * parseInt(data.service.default_qty);
      var tp = parseFloat(data.tax_percentage);

      return (rate + (rate * tp) / 100).toFixed(2);
    }
  },
  methods: {
    tokenize(){
      this.hps.tokenize();
    },
    updateIsSignatureRequired(value){
      this.$store.commit(SET_IS_SIGNATURE_REQUIRED, value)
    },
    setArchival(e) {
      this.archivalItem = [];
      var id = e.target.value;

      this.archivalDataFetched(id, this.getTotalArchivalRateAmount, true);
    },
    setRenewDate() {
      this.$store.commit(SET_ARCHIVAL_RENEW_DATE, this.selected_renew_date);
    },

    archivalDataFetched(id, old_archival_amount = 0, flag = false) {
      // alert(id);

      var key = this.getArchivalRates.findIndex(
        x => x.archival_period.id == id
      );
      // var old_archival_amount = ;

      this.archival_total = 0;
      if (flag) {
        if (key > -1) {
          if (this.is_renew) {
            // console.log(this.getArchivalDate);
            var duration = this.getArchivalRates[key].archival_period.duration;
            if (!this.getArchivalDate == "") {
              var dateObject = new Date(this.getArchivalDate);

              dateObject.setFullYear(dateObject.getFullYear() + duration);
            } else {
              dateObject = new Date();

              dateObject.setFullYear(dateObject.getFullYear() + duration);
            }
            this.selected_renew_date = moment(dateObject).format("YYYY-MM-DD");
            var set_date = new Date(this.selected_renew_date);
            this.set_upper_limit = set_date.setMonth(set_date.getMonth() + 3);
            document.getElementById("inputdate").max = moment(
              this.set_upper_limit
            ).format("YYYY-MM-DD");

            this.set_lower_limit = set_date.setMonth(set_date.getMonth() - 6);
            document.getElementById("inputdate").min = moment(
              this.set_lower_limit
            ).format("YYYY-MM-DD");
          }

          this.$store.commit(SET_ARCHIVAL_RENEW_DATE, this.selected_renew_date);
          this.archivalItem = this.getArchivalRates[key];
          var amount = parseFloat(this.getArchivalRates[key].rate);
          var taxPer = parseFloat(this.getArchivalRates[key].tax_percentage);
          var tax = parseFloat(((amount * taxPer) / 100).toFixed(2));
          this.archival_total = amount + tax;
          this.$store.commit(SET_ARCHIVAL_PERIOD_ID, id);
        } else {
          this.archivalItem = 0;
          if (!this.getArchivalDate == "") {
            dateObject = new Date(this.getArchivalDate);
          } else {
            dateObject = new Date();
          }
          this.selected_renew_date = moment(dateObject).format("YYYY-MM-DD");
          set_date = new Date(this.selected_renew_date);
          this.set_upper_limit = set_date.setMonth(set_date.getMonth() + 3);
          document.getElementById("inputdate").max = moment(
            this.set_upper_limit
          ).format("YYYY-MM-DD");

          this.set_lower_limit = set_date.setMonth(set_date.getMonth() - 6);
          document.getElementById("inputdate").min = moment(
            this.set_lower_limit
          ).format("YYYY-MM-DD");
          this.$store.commit(SET_ARCHIVAL_PERIOD_ID, "");
          this.$store.commit(SET_ARCHIVAL_RENEW_DATE, "");
          this.selected_renew_date = "";
        }
        var old_discount_amount = (
          (old_archival_amount * parseFloat(this.getPromoCodeDiscountRate)) /
          100
        ).toFixed(2);
        var archival_discount_amount = (
          (parseFloat(this.archival_total) *
            parseFloat(this.getPromoCodeDiscountRate)) /
          100
        ).toFixed(2);
        var discount_amount = (
          parseFloat(this.getTotalDiscountAmount) +
          parseFloat(archival_discount_amount) -
          parseFloat(old_discount_amount)
        ).toFixed(2);
        this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, discount_amount);

        old_archival_amount = (
          old_archival_amount -
          (old_archival_amount * this.getPromoCodeDiscountRate) / 100
        ).toFixed(2);

        this.$store.commit(
          SET_TOTAL_SERVICE_AMOUNT,
          (
            this.archival_total +
            parseFloat(this.getTotalServiceAmount) -
            (parseFloat(this.archival_total) * this.getPromoCodeDiscountRate) /
              100 +
            -parseFloat(old_archival_amount)
          ).toFixed(2)
        );

        this.$store.commit(
          SET_ARCHIVAL_TOTAL_RATE_AMOUNT,
          parseFloat(this.archival_total)
        );
      } else {
        if (key > -1) {
          this.archivalItem = this.getArchivalRates[key];
        }
      }

      // this.setQty();

      // this.$store.commit(SET_ADD_RATE_QTY, this.addQty);
      // var add_rate_ = parseFloat(this.rateData.additional_rate);

      // var tax_percentage = parseFloat(this.rateData.tax_percentage);

      // this.$store.commit(
      //   SET_RATE_TOTAL_AMOUNT,
      //   (
      //     this.addQty * add_rate_ +
      //     (this.addQty * add_rate_ * tax_percentage) / 100 +
      //     this.archival_total
      //   ).toFixed(2)
      // );
    },
    async recaptchafun() {
      const recaptcha = await load(this.sitekey, {
        autoHideBadge: true
      });
      const token = await recaptcha.execute("pay");

      // console.log(token); // Will also print the token
      this.$store.dispatch(RECAPTCHATOKENVERIFY, token).then(res => {
        let data = JSON.parse(res);
        if (data.success) {
          this.$store.commit(RECAPTCHATOKEN, token);
        }
      });
    },
    setQty() {
      this.$store.commit(SET_QTY, this.qty);
      var add_rate = parseFloat(this.getfClientRate.rate);
      var tax_amt = (add_rate * this.getfClientRate.tax_percentage) / 100;
      this.$store.commit(
        SET_RATE_TOTAL_AMOUNT,
        (this.qty * (add_rate + tax_amt)).toFixed(2)
      );
      this.$store.commit(
        SET_TOTAL_SERVICE_AMOUNT,
        (
          parseFloat(this.qty * (add_rate + tax_amt)) +
          parseFloat(this.getTotalArchivalRateAmount)
        ).toFixed(2)
      );
    },
    setFrame: function() {
      let url = this.getServiceProviderData.token_url;
      document.getElementById("tokenframe").src = url;
    },
    toggleCountriesPhoneCode(flag) {
      if (flag) {
        this.id_scroll_list_country =
          "scroll_li" + this.getPaymentCardPhonecode.code;
      }
      this.showCountriesWithPhoneCode = flag;
      this.$refs.email.$el.focus();
    },
    updatePostalZip(e) {
      var value = e.target.value;

      this.$store.commit(SET_PAYMENT_CARD_NUMBER_POSTAL, value);
    },
    updatePaymentCardPhone(e) {
      var value = e.target.value;
      this.$store.commit(SET_PAYMENT_CARD_NUMBER_PHONE, value);
    },
    addQty_() {
      this.addQty = this.addQty + 1;
      this.$store.commit(SET_ADD_RATE_QTY, this.addQty);
      var add_rate = parseFloat(this.getfClientRate.additional_rate);
      var tax_percentage = parseFloat(this.getfClientRate.tax_percentage);

      this.$store.commit(
        SET_ADDITIONAL_CARD_TOTAL_AMOUNT,
        (
          this.addQty * add_rate +
          (this.addQty * add_rate * tax_percentage) / 100
        ).toFixed(2)
      );
      var discount_amount = (
        ((parseFloat(this.getTotalAdditionalAmount) +
          parseFloat(this.getTotalRateAmount) +
          parseFloat(this.getTotalArchivalRateAmount)) *
          parseFloat(this.getPromoCodeDiscountRate)) /
        100
      ).toFixed(2);
      this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, discount_amount);
      this.$store.commit(
        SET_TOTAL_SERVICE_AMOUNT,
        (
          parseFloat(this.getTotalAdditionalAmount) +
          parseFloat(this.getTotalRateAmount) +
          parseFloat(this.getTotalArchivalRateAmount) -
          discount_amount
        ).toFixed(2)
      );
    },
    miuQty_() {
      if (this.addQty > 0) {
        this.addQty = this.addQty - 1;
        this.$store.commit(SET_ADD_RATE_QTY, this.addQty);
        var add_rate = parseFloat(this.getfClientRate.additional_rate);
        var tax_percentage = parseFloat(this.getfClientRate.tax_percentage);
        this.$store.commit(
          SET_ADDITIONAL_CARD_TOTAL_AMOUNT,
          (
            this.addQty * add_rate +
            (this.addQty * add_rate * tax_percentage) / 100
          ).toFixed(2)
        );

        var discount_amount = (
          ((parseFloat(this.getTotalAdditionalAmount) +
            parseFloat(this.getTotalRateAmount) +
            parseFloat(this.getTotalArchivalRateAmount)) *
            parseFloat(this.getPromoCodeDiscountRate)) /
          100
        ).toFixed(2);
        this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, discount_amount);
        this.$store.commit(
          SET_TOTAL_SERVICE_AMOUNT,
          (
            parseFloat(this.getTotalAdditionalAmount) +
            parseFloat(this.getTotalRateAmount) +
            parseFloat(this.getTotalArchivalRateAmount) -
            discount_amount
          ).toFixed(2)
        );
      }
    },
    removeAdditional() {
      this.addQty = 0;
      this.$store.commit(SET_ADD_RATE_QTY, 0);
      this.$store.commit(SET_ADDITIONAL_CARD_TOTAL_AMOUNT, "0.00");
      var discount_amount = (
        ((parseFloat(0) + parseFloat(this.getTotalRateAmount) + parseFloat(this.getTotalArchivalRateAmount)) *
          parseFloat(this.getPromoCodeDiscountRate)) / 100
      ).toFixed(2);
      this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, discount_amount);
      this.$store.commit(
        SET_TOTAL_SERVICE_AMOUNT,
        (parseFloat(this.getTotalRateAmount) + parseFloat(this.getTotalArchivalRateAmount) - discount_amount).toFixed(2)
      );
    },
    updateAbCode(e) {
      this.$store.commit(UPDATE_ABBREVIATION_CODE, e.target.value);
      this.abbreviation_code_error = false;
      if (this.getAbbreviationCode.data.length < 1) {
        this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
          data: { show_payment_option: true },
          success: "none"
        });
      }

      //     this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
      //   data: [],success:true
      // });
    },
    updatePRCode(e) {
      this.$store.commit(UPDATE_PROMO_CODE, e.target.value);
      this.promo_code_error = false;
      if (this.getPromoCode.data.length < 1) {
        this.$store.commit(SET_CHECK_F_PROMO_CODE, {
          data: { discount_percentage: 0 },
          success: "none"
        });
      }

      //     this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
      //   data: [],success:true
      // });
    },
    change_abbr() {},

    updateCardNumber(cardno) {
      delete this.errors["card_number"];
      var value = cardno;
      if (value.length < 1) {
        this.errors.card_number = {
          0: "Card No. cannot be empty"
        };
      }
      var cardType = "";

      var paymentCardProperty = {
        cvv_placeholder: "3 digit",
        cvv_mask: "###"
      };

      let re = new RegExp("^4");
      if (value.match(re) != null) {
        cardType = "visa";
      }

      re = new RegExp("^(34|37)");
      if (value.match(re) != null) {
        cardType = "amex";
        paymentCardProperty = {
          cvv_placeholder: "4 digit",
          cvv_mask: "####"
        };
      }

      re = new RegExp("^5[1-5]");
      if (value.match(re) != null) {
        cardType = "mastercard";
      }

      re = new RegExp("^6011");
      if (value.match(re) != null) {
        cardType = "discover";
      }

      // /The card number entered is not compliant, please check and re-enter.
      //Card No. length is less than the minimum length
      //The card number entered is not compliant, please check and re-enter.

      // alert(value);

      this.$store.commit(SET_PAYMENT_CARD_PROPERTY, paymentCardProperty);

      if (value.length > 6) {
        if (cardType == "") {
          this.errors.card_number = {
            0: "The card number entered is not compliant, please check and re-enter."
          };
        }
        this.$store.commit(SET_PAYMENT_CARD_TYPE, cardType);
      } else {
        this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
      }
      this.$store.commit(SET_PAYMENT_CARD_NUMBER, value);
    },
    updateCardHolderName(e) {
      delete this.errors["card_holder_name"];
      var value = e.target.value;
      // alert(value);
      this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, value);
      if (value.length < 1) {
        this.errors.card_holder_name = {
          0: "Card holder name cannot be empty"
        };
      }
    },
    updateCardAddress(e) {
      delete this.errors["card_address"];
      var value = e.target.value;
      // alert(value);
      this.$store.commit(SET_PAYMENT_CARD_ADDRESS, value);
      if (value.length < 1) {
        this.errors.card_address = {
          0: "Card Address cannot be empty"
        };
      }
    },
    updateCardcity(e) {
      delete this.errors["card_city"];
      var value = e.target.value;
      // alert(value);
      this.$store.commit(SET_PAYMENT_CARD_CITY, value);
      if (value.length < 1) {
        this.errors.card_city = {
          0: "City cannot be empty"
        };
      }
    },
    updateCardCvvNumber(e) {
      delete this.errors["card_cvv_no"];
      var value = e.target.value;
      if (value.length < 1) {
        this.errors.card_cvv_no = {
          0: "Security Code cannot be empty"
        };
      }
      // alert(value);
      this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, value);
    },
    updateCardExpiry(e) {
      delete this.errors["card_expiry"];
      // this.errors.card_expiry = null;

      var value = e.target.value;
      // alert(value);
      this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, value);
      if (value.length < 1) {
        this.errors.card_expiry = {
          0: "Expiration date cannot be empty"
        };
      }
      if (value.length == 5) {
        var today = new Date();
        var someday = new Date();
        someday.setFullYear(
          today
            .getFullYear()
            .toString()
            .substr(0, 2) + value.split("/")[1],
          value.split("/")[0],
          1
        );

        if (someday < today) {
          this.errors.card_expiry = {
            0: "Card Expiration Date is not validated"
          };
        }
      }
    },

    updatePaymentType(value) {
      if (this.onSitePayment) {
        value = "O";
        this.errors = [];
        this.$store.commit(SET_PAYMENT_CARD_NUMBER, "");
        this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, "");
        this.$store.commit(SET_PAYMENT_CARD_ADDRESS, "");
        this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, "");
        this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, "");
        this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
        this.$store.commit(SET_PAYMENT_CARD_CITY, "");
        this.$store.commit(CARD_COUNTRY, "");
        this.$store.commit(CARD_STATE, "");
      } else {
        value = "C";
      }
      this.$store.commit(UPDATE_PAYMENT_TYPE, value);
    },
    updateAbbreviationCodeFun(e) {
      this.$store.commit(UPDATE_ABBREVIATION_CODE, e.target.value);
    },
    removeAbbCode() {
      this.$store.commit(UPDATE_PAYMENT_TYPE, "C");
      this.onSitePayment = 0;
      this.$store.commit(UPDATE_ABBREVIATION_CODE, "");
      this.abbreviation_code_error = false;
      this.paymentMethod = true;
      this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
        data: { show_payment_option: true },
        success: "none"
      });
    },
    checkAbbreviationCode() {
      this.$store.commit(UPDATE_ABBREVIATION_CODE, this.abree_code);
      if (this.updateAbbreviationCode != "") {
        this.abbreviation_code_error = true;

        this.$store
          .dispatch(CHECK_F_ABBREVIATION_CODE, {
            code: this.updateAbbreviationCode,
            client_slug: this.$route.params.client_slug
          })
          .then(data => {
            if (data.success) {
              this.paymentMethod = data.data.show_payment_option;
              if (!data.data.show_payment_option) {
                this.$store.commit(UPDATE_PAYMENT_TYPE, "A");
              }
              this.abree_code = "";
            } else {
              this.paymentMethod = true;
            }
          });
      } else {
        this.abbreviation_code_error = false;
      }
    },
    updateState(e) {
      this.$store.commit(CARD_STATE, e.target.value);
      var value = e.target.value;
      if (value.length < 1) {
        this.errors.card_city = {
          0: "State cannot be empty"
        };
      }
    },
    updateCountry(e) {
      this.$store.commit(CARD_COUNTRY, e.target.value);
      this.$store.commit(CARD_STATE, "");
      var value = e.target.value;
      if (value.length < 1) {
        this.errors.card_city = {
          0: "Country cannot be empty"
        };
      }
    },
    removePromoCode() {
      // this.$store.commit(UPDATE_PAYMENT_TYPE, "C");
      // this.onSitePayment = 0;
      this.$store.commit(UPDATE_PROMO_CODE, "");
      this.promo_code_error = false;
      // this.paymentMethod = true;
      this.$store.commit(SET_CHECK_F_PROMO_CODE, {
        data: { discount_percentage: 0 },
        success: "none"
      });
      this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, 0);
      this.$store.commit(SET_PROMOCODE_DISCOUNT_PERCENTAGE, 0);
      if(this.getIsApostilleService){
        this.$store.commit(
          SET_TOTAL_SERVICE_AMOUNT,
          (
            parseFloat(this.getApostilleSubmittedData.total_cost.grand_total)
          ).toFixed(2)
        );
      }else{
        this.$store.commit(
          SET_TOTAL_SERVICE_AMOUNT,
          (
            parseFloat(this.getTotalAdditionalAmount) +
            parseFloat(this.getTotalRateAmount) +
            parseFloat(this.getTotalArchivalRateAmount)
          ).toFixed(2)
        );
      }
    },
    updateOri(e) {
      this.$store.commit(UPDATE_SERVICE_ORI_CODE, e.target.value);
      this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, {
        data: "",
        success: "none"
      });
      //     this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
      //   data: [],success:true
      // });
    },
    checkServiceOri() {
      // this.service_ori = this.updateServiceOriCode;

      if (this.updateServiceOriCode != "") {
        this.service_ori_code_error = true;
        var service_id = this.getServiceId;
        this.$store
          .dispatch(CHECK_F_SERVICE_ORI_CODE, {
            service_code: this.getServiceTypeCode,
            code: this.updateServiceOriCode,
            client: this.$route.params.id,
            service: service_id
          })
          .then(data => {
            if (data.success) {
              this.$store.commit(UPDATE_SERVICE_ORI_CODE, data.data.ori_number);
              this.$store.commit(UPDATE_ORI, data.data.service_ori_id);
              this.$store.commit(SET_F_CLIENT_RATE, data.data);
              // this.getfClientRate = data
              if (data.data.service.is_drug_testing) {
                this.qty = this.getQty;
                this.recipient = this.getMultirecipient;
              } else {
                this.qty = data.data.service.default_qty;
              }

              var rate = parseFloat(data.data.rate);
              var tax_percentage_amount = parseFloat(
                (
                  (parseFloat(data.data.tax_percentage) / 100) *
                  rate *
                  this.qty
                ).toFixed(2)
              );
              //  (rateData.additional_rate * getAddQty)
              //                   | taxAmount(rateData.tax_percentage)
              var tax_additional_amount =
                (parseFloat(data.data.tax_percentage) / 100) *
                data.data.additional_rate *
                this.getAddQty;
              this.$store.commit(
                SET_ADDITIONAL_CARD_TOTAL_AMOUNT,

                parseFloat(
                  data.data.additional_rate * this.getAddQty +
                    tax_additional_amount
                ).toFixed(2)
              );
              this.$store.commit(
                SET_RATE_TOTAL_AMOUNT,
                parseFloat(rate * this.qty + tax_percentage_amount).toFixed(2)
              );

              this.$store.commit(
                SET_TOTAL_SERVICE_AMOUNT,
                parseFloat(rate * this.qty + tax_percentage_amount).toFixed(2)
              );
              this.service_ori = "";
            } else {
              this.service_ori_code_error = true;
            }
          });
      } else {
        this.service_ori_code_error = true;
      }
    },
    removeServiceOri() {
      this.$store.commit(UPDATE_ORI, "");
      //  this.$store.commit(UPDATE_PAYMENT_TYPE,this.getPaymentType);
      this.service_ori_code_error = false;
      this.$store.commit(UPDATE_SERVICE_ORI_CODE, "");
      this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, {
        data: "",
        success: "none"
      });
    },
    checkPromoCode() {
      this.$store.commit(UPDATE_PROMO_CODE, this.promo_code);
      if (this.updatePromoCode != "") {
        this.promo_code_error = true;

        this.$store
          .dispatch(CHECK_F_PROMO_CODE, {
            code: this.updatePromoCode,
            client_slug: this.$route.params.client_slug
          })
          .then(data => {
            if (data.success) {
              this.promo_code_error = false;

              // this.paymentMethod = data.data.show_payment_option;
              if (data.data.discount_percentage > 0) {
                this.$store.commit(
                  SET_PROMOCODE_DISCOUNT_PERCENTAGE,
                  parseFloat(data.data.discount_percentage).toFixed(2)
                );
                if(this.getIsApostilleService){
                  this.$store.commit(SET_PROMOCODE_DISCOUNT_AMOUNT, 
                    (parseFloat(this.getApostilleSubmittedData.total_cost.grand_total) * (parseFloat(data.data.discount_percentage) / 100)).toFixed(2)
                  )
                  this.$store.commit(SET_TOTAL_SERVICE_AMOUNT, (parseFloat(this.getApostilleSubmittedData.total_cost.grand_total) - parseFloat(this.getTotalDiscountAmount)).toFixed(2) )
                }else{
                  this.$store.commit(
                    SET_PROMOCODE_DISCOUNT_AMOUNT,
                    (
                      ((parseFloat(this.getTotalRateAmount) +
                        parseFloat(this.getTotalAdditionalAmount) +
                        parseFloat(this.getTotalArchivalRateAmount)) *
                        parseFloat(data.data.discount_percentage)) /
                      100
                    ).toFixed(2)
                  );
                  this.$store.commit(
                    SET_TOTAL_SERVICE_AMOUNT,
                    (
                      parseFloat(this.getTotalRateAmount) +
                      parseFloat(this.getTotalAdditionalAmount) +
                      parseFloat(this.getTotalArchivalRateAmount) -
                      parseFloat(this.getTotalDiscountAmount)
                    ).toFixed(2)
                  );
                }
              }

              this.promo_code = "";
            }
          });
      } else {
        this.promo_code_error = false;
      }
    }
  }
  // components: { VueCreditCard }
};
</script>